/* https://github.com/utatti/perfect-scrollbar */
/* http://utatti.github.io/perfect-scrollbar/ */
import { Directive, ElementRef, OnDestroy, HostListener, Output, EventEmitter, AfterViewInit, Input, AfterViewChecked } from '@angular/core';

import { ScrollService } from './scroll.shared.service';
import * as Decorators from '../../decorators';
import { Subscription } from 'rxjs';

import PerfectScrollbar from 'perfect-scrollbar'; /* TODO - switchTo this: https://www.npmjs.com/package/ngx-perfect-scrollbar */

@Decorators.AutoUnsubscribe()
@Directive({
    selector: '[directive-scroll]',
})
export class ScrollDirective implements OnDestroy, AfterViewInit, AfterViewChecked {
    private _init: boolean = false;
    private _scrollElem: PerfectScrollbar;
    private _height!: number;

    @Input() public disabledBelow: number = null;
    @Input() public hideScrollX: boolean = false;
    @Output() public onScrollInit: EventEmitter<HTMLDivElement> = new EventEmitter();
    @Output() public onScrollY: EventEmitter<Event> = new EventEmitter();
    @Output() public onScrollUpdate: EventEmitter<boolean> = new EventEmitter(true);

    public updateListener: Subscription;

    constructor(
        private _elementRef: ElementRef,
        private _scrollService: ScrollService,
    ) {
        //
        //  Initialize scrollbar
        //
        this._scrollElem = new PerfectScrollbar(
            this._elementRef.nativeElement,
            {
                wheelPropagation: false
            }
        );

        //
        //  Listening for update requests from above;
        //  Force inner bars update
        //
        this.updateListener = this._scrollService.onUpdate.subscribe(update => {
            this._scrollElem.update();
            this.onScrollUpdate.emit(true);
        });

    }

    ngAfterViewInit() {
        if (this.hideScrollX) this._scrollElem.settings.suppressScrollX = true;
        if (this.disabledBelow !== null && window.innerWidth < this.disabledBelow) {
            this._scrollElem.destroy();

            return;
        }

        if (!this._init) {
            this._init = true;
            this.onScrollInit.emit(this._elementRef.nativeElement);
            /* AOLO-110 */
            setTimeout(() => {
                this._scrollElem.update();
            }, 10);
        }
    }

    ngAfterViewChecked(): void {
        if (this._elementRef && this._elementRef.nativeElement) {
            if (this._elementRef.nativeElement.clientHeight !== this._height) {

                this._height = this._elementRef.nativeElement.clientHeight;
                this._scrollElem.update();
            }
        }
    }

    ngOnDestroy() {
        this._scrollElem.destroy();
    }

    @HostListener('scroll', ['$event']) public onScroll($event) {
        if (this._scrollElem.reach.y !== 'end') {
            this.onScrollY.emit($event);
        }
    }
}
